import { TypographyStyle } from '@mui/material/styles';
import { css } from 'styled-components';

export const typographyToCss = (typography: TypographyStyle) => css`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize};
  font-weight: ${typography.fontWeight};
  line-height: ${typography.lineHeight};
`;
